module.exports = __webpack_public_path__ + "static/img/ky-qrcode.f3543c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactUs/ky-qrcode.png
// module id = CDKi
// module chunks = 0